import { render, staticRenderFns } from "./GuideBookPaperArticles.vue?vue&type=template&id=12f54bfe"
import script from "./GuideBookPaperArticles.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports